import { t } from "ttag";

import { LogoIcon } from "metabase/common/components/LogoIcon";
import { useSelector } from "metabase/lib/redux";
import { getApplicationName } from "metabase/selectors/whitelabel";
import {
  Anchor,
  Box,
  Divider,
  Flex,
  Modal,
  type ModalProps,
  Stack,
  Text,
  Title,
} from "metabase/ui";

const GCS_SOURCE_URL =
  "https://storage.googleapis.com/narvar-analytics/source/narvar-metabase-oss-latest.tar.gz";
const GCS_COPYRIGHT_URL =
  "https://storage.googleapis.com/narvar-analytics/source/COPYRIGHT_AND_LEGAL_NOTICES.txt";

export const AboutModal = ({
  onClose,
  opened,
}: Pick<ModalProps, "onClose" | "opened">) => {
  const applicationName = useSelector(getApplicationName);

  return (
    <Modal opened={opened} onClose={onClose} withCloseButton={false} size={475}>
      <Flex direction="column" align="center" pb="lg">
        <Box c="brand" pb="md">
          <LogoIcon height={48} />
        </Box>
        <Stack gap={14} align="center">
          <Title order={2}>{t`Thanks for using ${applicationName}!`}</Title>
          <Divider size={2} w="100%" />
          <Stack gap={6} align="center">
            <Text fz="sm" fw="bold" c="text-secondary" lh="sm" ta="center">
              {t`Narvar Analytics Dashboarding Tool`}
            </Text>
            <Text fz="sm" fw="bold" c="text-secondary" lh="sm" ta="center">
              {t`Copyright (C) 2026 Narvar`}
            </Text>
          </Stack>
          <Divider size={1} w="100%" />
          <Stack gap={8} align="center">
            <Text fz="sm" fw="bold" c="text-secondary" lh="sm" ta="center">
              {t`This software is licensed under the AGPL License.`}
            </Text>
            <Text fz="sm" fw="bold" c="text-secondary" lh="sm" ta="center">
              {t`April 2, 2026 modified source code available`}{" "}
              <Anchor href={GCS_SOURCE_URL} target="_blank" fz="sm" fw="bold">
                {t`here`}
              </Anchor>
              {"."}
            </Text>
            <Text fz="sm" fw="bold" c="text-secondary" lh="sm" ta="center">
              {t`Copyright and legal notices available`}{" "}
              <Anchor href={GCS_COPYRIGHT_URL} target="_blank" fz="sm" fw="bold">
                {t`here`}
              </Anchor>
              {"."}
            </Text>
          </Stack>
        </Stack>
      </Flex>
    </Modal>
  );
};
